export const GET_OPTIONS_REQUEST = "GET_OPTIONS_REQUEST";
export const GET_OPTIONS_SUCCESS = "GET_OPTIONS_SUCCESS";
export const GET_OPTIONS_FAIL = "GET_OPTIONS_FAIL";

export const GET_TICKET_REQUEST = "GET_TICKET_REQUEST";
export const GET_TICKET_SUCCESS = "GET_TICKET_SUCCESS";
export const GET_TICKET_FAIL = "GET_TICKET_FAIL";
